<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import {getDunhuangData} from "@/api/forecastManagement/tagService";

export default {
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getDunhuangData
      },
      config: {},
      footer: {},
      modals: {

      },
      header: {
        searchs: [
          {
            key: "status",
            placeholder() {
              return this.$tz("订单状态");
            },
            component: "Select",
            options: [
              {value: 1, label: '已下单'},
              {value: 2, label: '待入库'},
              {value: 3, label: '待支付'},
              {value: 4, label: '待出库'},
              {value: 5, label: '已出库'},
              {value: 6, label: '已取消'},
            ],
            default: 3
          },

          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {

        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("订单号码"),
          key: "shipment_number",
          minWidth: 130,
          copy: true,
          header: {
            copy: true
          },
        },
        {
          name: () => this.$tz("敦煌单号"),
          key: "client_ref",
          minWidth: 130,
          copy: true,
          header: {
            copy: true
          },
        },
        {
          name: () => this.$tz("订单状态"),
          key: "status",
          minWidth: 140,
          header: {
            copy: true
          },
        },
        {
          name: () => this.$tz("创建数据"),
          key: "create_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("最后检查时间"),
          key: "update_time",
          minWidth: 130
        },
      ]
    };
  }
};
</script>

<style scoped></style>
